import { getUrlParameter } from "../utils/utils.common";
import { ifCanPushDatalayer } from "./utils/utils.dataLayer.common";
import { getCurrentEnv } from "../utils/utils.common";
import logAmplitudeEvent from "../../../components/amplitude";
import acceptedCookiePolicy from "../../../components/onetrust/cookiePolicy";
import listenToMutinyEventInDataLayer from "../amplitude/dataLayerListener.common";

const utmsKeys = [
    'utm_campaign',
    'utm_medium',
    'utm_content',
    'utm_source',
    'utm_term',
    'utm_adgroup'
];

const parameters = [...utmsKeys];

//UCS001
const dataLayerPageLoad = () => {
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                // Amplitude page properties
                const domain = location.hostname || null;
                const href = location.href || null;
                const path = location.pathname || null;
                const title = document.title || null;
                const url = location.href.split('?')[0] || null;
                const referrer = document.referrer || null;
                const search = location.search || null;
                const hash = location.hash || null;
                
                const searchParam = location.search.toLowerCase();
                const mktoUtmsParam = searchParam.includes('utm_');
                let utmParameters = {};

                if (mktoUtmsParam) {
                    for (let i = 0; i < parameters.length; i++) {
                        let utmField = parameters[i];
                        const utmValue = getUrlParameter(parameters[i]);
        
                        if(getUrlParameter(utmField)) {
                            utmParameters[utmField] = utmValue;
                        }
                    }
                }   
                
                logAmplitudeEvent({
                    event_type: "Page Viewed",
                    properties: {
                        domain: domain,
                        location: href,
                        path: path,
                        title: title,
                        url: url,
                        referrer: referrer,
                        search: search,
                        hash: hash,
                        ...utmParameters
                    },
                });
                listenToMutinyEventInDataLayer();
            }
        },
    });
    ifCanPushDatalayer({
        then: () => {
            const path = window.location.pathname;
            const segment = path.split("/").filter((segment) => segment);

            const lang = document.querySelector("html").getAttribute("lang");
            const sessionID = localStorage.getItem("visitorId") ? localStorage.getItem("visitorId") : "";
            const websiteCategory = segment[1] ? segment[1] : "homepage";
            const contentType = segment[2] ? segment[2] : "";

            const lineOfBusinessTitle = document.querySelector('[data-vue-component="sticky-secondary-navigation"] .cv-title-5');
            const lineOfBusiness = lineOfBusinessTitle !== null && websiteCategory === "solutions" ? lineOfBusinessTitle.innerText.toLowerCase() : "";

            const pageLineOfBusinessMetaTag = document.querySelector('meta[name="coveo:platformsolutions"]');
            let pageLineOfBusiness = "";

            if (pageLineOfBusinessMetaTag) {
                pageLineOfBusiness = pageLineOfBusinessMetaTag.content.split(";")[0];
            }

            dataLayerBus.push({
                event: "page_view",
                event_name: "page_view",
                page: {
                    language: lang,
                    environment: getCurrentEnv(),
                    website_category: websiteCategory,
                    content_type: contentType,
                    line_of_business: lineOfBusiness || pageLineOfBusiness,
                },
                user: {
                    session_id: sessionID,
                    user_solutions: [...CoveoWebsite.meta.solutionTags],
                },
            });
        },
    });
};

export default dataLayerPageLoad;
